<template>
    <b-modal :title="t('Notify patient')"
             v-model="modalShow"
             modal-class="notification-patient"
             :hide-footer="type === null"
             footer-class="justify-content-between"
    >
        <div class="row" v-if="type === null">
            <div class="col-12 col-sm-12 mb-1">{{t('Select message type')}}</div>
            <div class="col-6 col-sm-6">
                <button type="button" class="btn btn-message" v-on:click="setType('patientMail')">
                    <font-awesome-icon icon="at"/>
                    <br>
                    {{t('E-mail')}}
                </button>
            </div>
            <div class="col-6 col-sm-6">
                <button type="button" class="btn btn-message" v-on:click="setType('patientTextMessages')">
                    <font-awesome-icon icon="mobile-alt"/>
                    <br>
                    {{t('Text message')}}
                </button>
            </div>
        </div>
        <div class="text-center mt-5 mb-5" v-if="loading">
            <loading size="xs"/>
            {{t('Loading')}}
        </div>
        <titan-form ref="contactForm"
                    :schema="schema"
                    :render-in-card="false"
                    v-if="type !== null && loading === false"
                    v-on:saveData="saveForm()"
                    :showMessage="false"
                    :model="formData"
        />
        <template slot="modal-footer">
            <button type="button" class="btn btn-success" @click="saveForm()">
                <font-awesome-icon icon="paper-plane"/>
                {{t('Send')}}
            </button>
            <button type="button" class="btn btn-outline-secondary" @click="reset(); modalShow = true">
                {{t('Go back')}}
            </button>
        </template>
    </b-modal>
</template>
<script>
    import Loading from '../../../core/Components/loading';
    import TitanForm from '../../../core/Form/Form'
    import VueFormGenerator from "vue-form-generator";

    // Font awesome
    import {library} from '@fortawesome/fontawesome-svg-core'
    import {faMobileAlt, faAt, faPaperPlane} from '@fortawesome/free-solid-svg-icons'

    library.add(faMobileAlt, faAt, faPaperPlane);

    export default {
        components: {
            Loading,
            TitanForm
        },
        methods: {
            saveForm() {
                if (this.$refs.contactForm.isValid()) {
                    this.loading = true;
                    const data = {
                        id: this.patientId,
                        type: this.type,
                        serviceType: 'patientMail' === this.type ? 'email' : 'sms',
                        subject: this.formData.subject,
                        text: this.formData.text,
                        cellphone: this.formData.cellphone,
                        email: this.formData.email
                    };
                    this.$store.dispatch('service/send', data).then(() => {
                        this.reset();
                    }).catch(() => {
                        this.loading = false;
                    });
                }
            },
            setType(type) {
                this.type = type;
                this.schema[0].fields[1].visible = type === 'patientMail';
                this.schema[0].fields[2].type = type === 'patientMail' ? 'titanRedactor' : 'textArea';
                this.schema[0].fields[3].visible = 'patientMail' === type;// && (null === this.patientEmail || '' === this.patientEmail);
                this.schema[0].fields[4].visible = 'patientTextMessages' === type;// && (null === this.patientCellphone || '' === this.patientCellphone);
                this.schema[0].fields[0].codeBook = undefined;
                const dataParams = {
                    id: this.patientId,
                    type: type,
                };
                this.loading = true;
                this.$store.dispatch('codeBook/patientTemplates', dataParams).then(res => {
                    this.schema[0].fields[0].values = res;
                    this.schema[0].fields[0].values = res;
                    this.loading = false;
                }).catch(() => {
                    this.loading = false;
                });
            },
            openModal(patient) {
                this.modalShow = true;
                this.patientId = patient.id;
                this.patientCellphone = patient.phone;
                this.patientEmail = patient.email;
                this.formData.cellphone = patient.phone;
                this.formData.email = patient.email;
            },
            reset() {
                this.type = null;
                this.modalShow = false;
                this.loading = false;
                this.formData = {
                    template: null,
                    subject: '',
                    text: '',
                    cellphone: this.patientCellphone,
                    email: this.patientEmail,
                };
            }
        },
        data() {
            return {
                patientId: null,
                patientCellphone: '',
                patientEmail: '',
                loading: false,
                modalShow: false,
                formData: {
                    template: null,
                    subject: '',
                    text: '',
                    cellphone: '',
                    email: '',
                },
                type: null,
                schema: [
                    {
                        name: this.t('Base patient info'),
                        type: 'main',
                        showHeading: false,
                        fields: [
                            {
                                type: 'titanSelect',
                                values: [],
                                label: this.t('Templates'),
                                model: 'template',
                                hint: this.t('Select template or write customer message'),
                                onSelect: (item) => {
                                    if (item !== null) {
                                        this.formData.subject = item.name;
                                        this.formData.text = item.text;
                                    }
                                }
                            },
                            {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('Subject'),
                                model: 'subject',
                                required: true,
                                validator: VueFormGenerator.validators.required,
                                visible: true,
                            }, {
                                type: 'textArea',
                                label: this.t('Message'),
                                rows: 4,
                                model: 'text',
                                required: true,
                                validator: VueFormGenerator.validators.required,
                            },
                            {
                                type: 'input',
                                inputType: 'email',
                                label: this.t('E-mail'),
                                model: 'email',
                                required: true,
                                validator: VueFormGenerator.validators.email,
                                visible: false
                            },
                            {
                                type: 'input',
                                inputType: 'phone',
                                label: this.t('Cellphone'),
                                model: 'cellphone',
                                required: true,
                                visible: false
                            },
                        ]
                    }
                ],
            }
        }
    }
</script>
<style lang="scss">
    .notification-patient {

        .titan-form-block {
            margin-bottom: 0;
        }

        .btn-message {
            width: 100%;
            text-align: center;
            border: 1px solid #DEE1E6;
            line-height: 20px;
            padding: 25px 10px;
            -webkit-box-shadow: 0 0 41px 0 rgba(0, 0, 0, 0.05);
            -moz-box-shadow: 0 0 41px 0 rgba(0, 0, 0, 0.75);
            box-shadow: 0 0 41px 0 rgba(0, 0, 0, 0.06);

            svg {
                font-size: 25px;
                color: #3b4249;
            }

            &:hover {
                border-color: #009DFA;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/private/patients/notification.vue